import React from "react"
import PropTypes from 'prop-types';
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps';

export default class Button extends React.Component {
  constructor(props) {
    super(props);

    this.config = {
      types: [ 
        {
          title: 'primary',
          isDefault: true
        },
        'secondary',
        'primaryInverse',
        'secondaryInverse',
        'global',
        'icon'
      ],
      modifiers: [ 
        {
          title: 'md',
          isDefault: true
        },
        'sm',
        'lg',
        'block'
      ],
      states: [
        'disabled'
      ]
    }
  }

  render() {
    const {
      primary,
      secondary,
      primaryInverse,
      secondaryInverse,
      global,
      icon,
      md,
      sm,
      lg,
      block,
      children, 
      disabled, 
      data,
      href,
      target,
      ...rest
    } = this.props
    const clearedProps = clearProps(rest);
    const TagName = href ? 'a' : 'button'
    return <TagName
      {...clearedProps}
      className={resolveProps(this.props, this.config, 'Button')} 
      disabled={ disabled || (data||{}).isDisabled }
      href={href}
      target={target}
      >{icon ? <span className="mdn-Icon-fechar"></span> : children}</TagName>
  }
}

Button.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  icon: PropTypes.bool
}
